// Español (es)

export const es = {
  brand: { name: 'DoneLine', tagline: 'Gestor de proyectos personales' },
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    delete: 'Eliminar',
    rename: 'Renombrar',
    archive: 'Archivar',
    add: 'Añadir',
    close: 'Cerrar',
    edit: 'Editar',
    new: 'Nuevo',
    yes: 'Sí',
    no: 'No',
    back: 'Atrás',
    next: 'Siguiente',
    skip: 'Omitir',
    done: 'Hecho',
    loading: 'Cargando…',
    sending: 'Enviando…',
    saving: 'Guardando…',
    untitled: 'Sin título',
    today: 'Hoy',
    tomorrow: 'Mañana',
    yesterday: 'Ayer',
    none: 'Ninguno',
    optional: 'Opcional',
    requiredField: 'Requerido',
    confirmDelete: '¿Eliminar?',
  },
  nav: {
    today: 'Hoy',
    upcoming: 'Próximos',
    inbox: 'Bandeja',
    projects: 'Mis proyectos',
    tags: 'Etiquetas',
    reports: 'Informe semanal',
    settings: 'Ajustes',
    quickCapture: 'Captura rápida',
    search: 'Buscar',
    newProject: 'Nuevo proyecto',
    addSection: 'Añadir sección',
    menu: 'Menú',
    openMenu: 'Abrir menú',
  },
  search: {
    title: 'Buscar',
    placeholder: 'Buscar tareas, proyectos, etiquetas…',
    noResults: 'Sin resultados',
    tasks: 'Tareas',
    projects: 'Proyectos',
    tags: 'Etiquetas',
  },
  today: {
    title: 'Hoy',
    eyebrow: 'Hoy',
    overdue: 'Atrasadas',
    today: 'Hoy',
    completed: 'Completadas',
    empty: 'Nada para hoy. Respira ☕',
    summary: '{active} pendientes · {done} completadas',
    reschedule: 'Reprogramar',
    rescheduled: '{count} tarea(s) reprogramada(s)',
  },
  inbox: {
    title: 'Bandeja',
    eyebrow: 'Bandeja',
    empty: 'La bandeja está vacía.',
    pending: '{count} pendientes',
  },
  upcoming: {
    title: 'Próximos',
    eyebrow: 'Próximos 7 días',
    todayLabel: 'Hoy',
    tomorrowLabel: 'Mañana',
    empty: 'No hay tareas en los próximos 7 días.',
  },
  project: {
    eyebrow: 'Proyecto',
    notFound: 'Proyecto no encontrado',
    notFoundHint: 'Puede que se haya eliminado o archivado.',
    inProgress: '{count} en curso',
    completed: '{count} completadas',
    ungrouped: 'Sin agrupar',
    addSection: 'Añadir sección',
    listView: 'Lista',
    ganttView: 'Gantt',
    ganttZoomIn: 'Acercar',
    ganttZoomOut: 'Alejar',
    ganttWide: 'Ancho',
    ganttCompact: 'Compacto',
    empty: 'Aún no hay tareas en este proyecto',
    emptyHint: 'Usa el campo superior para añadir una.',
    sectionEmpty: '— Sin tareas —',
    completedSection: 'Completadas',
    newSectionTitle: 'Nueva sección',
    newSectionPlaceholder: 'Nombre de la sección',
    renameProjectTitle: 'Renombrar proyecto',
    renameProjectPlaceholder: 'Nombre del proyecto',
    editProjectTitle: 'Editar proyecto',
    color: 'Color',
    icon: 'Icono',
    noIcon: 'Sin icono',
    deleteProjectTitle: '¿Eliminar el proyecto "{name}"?',
    deleteProjectDesc: 'Las tareas de este proyecto se moverán a la Bandeja. No se puede deshacer.',
    archiveProject: 'Archivar',
    actionsMenu: 'Acciones del proyecto',
    renameSectionTitle: 'Renombrar sección',
    sectionDeleteTitle: '¿Eliminar la sección «{name}»?',
    sectionDeleteDesc:
      'Las tareas de esta sección pasarán a la raíz del proyecto. Esta acción no se puede deshacer.',
    sectionActionsMenu: 'Acciones de sección',
    sectionReorder: 'Reordenar sección',
    descriptionPlaceholder: 'Añade una nota sobre este proyecto…',
    descriptionEditHint: 'Compatible con Markdown · ⌘↵ guardar · Esc cerrar',
    descriptionEmpty: 'Haz clic para añadir una nota',
  },
  upgrade: {
    title: 'Actualiza a DoneLine Pro',
    featureLocked: '"{feature}" es una función Pro.',
    comingSoon: 'Pro estará disponible pronto — tu cuenta estará lista cuando lance.',
    signInFirst: 'Inicia sesión para mejorar',
    benefits: {
      unlimitedProjects: 'Proyectos ilimitados (gratis: máximo 3)',
      history: '365 días de historial de cambios (gratis: 7 días)',
      gantt: 'Vista Gantt',
      importExport: 'Importar / exportar tus datos',
      themes: 'Más temas, incluido Paper',
    },
    feature: {
      projects: 'Más de 3 proyectos',
      gantt: 'Vista Gantt',
      importExport: 'Importar / Exportar',
      paperTheme: 'Temas Pro',
    },
    cta: {
      stripe: 'Suscribirse — $2,99/mes o $29,99/año',
      apple: 'Suscribirse con Apple',
      google: 'Suscribirse con Google Play',
    },
  },
  plan: {
    title: 'Plan',
    description: 'Tu nivel de suscripción.',
    free: 'Gratis',
    pro: 'Pro',
    proAi: 'Pro AI',
    upgradeButton: 'Actualizar a Pro',
    devSwitchHint: 'Vista previa: cambia el plan temporalmente para probar los límites',
    switchToFree: 'Cambiar a Gratis (vista previa)',
    switchToPro: 'Cambiar a Pro (vista previa)',
  },
  reports: {
    eyebrow: 'Informe semanal',
    title: 'Resumen de los últimos 7 días',
    serverGeneratedAt: 'Generado por el servidor a las {time}',
    syncingFromServer: 'Sincronizando con el servidor…',
    computedLocally: 'Cálculo local',
    aiSummary: 'Resumen IA semanal',
    completedCount: 'Completadas',
    completionRate: 'Tasa de finalización',
    overdueCount: 'Atrasadas',
    dailyAverage: 'Promedio diario',
    dailyCompleted: 'Completadas por día',
    dailyCompletedAxis: '(tareas)',
    byProject: 'Por proyecto',
    noCompletedThisWeek: 'No has completado tareas esta semana.',
    serverNotReady:
      'El servidor aún no ha generado el informe de esta semana. El batch worker se ejecuta cada lunes a las 09:00 en tu zona horaria.',
  },
  settings: {
    display: {
      title: 'Visualización',
      description: 'Elige qué detalles muestran las listas de tareas.',
      tags: 'Etiquetas',
      tagsHint: 'Mostrar etiquetas en las filas',
      descriptionLabel: 'Descripción',
      descriptionHint: 'Mostrar una línea de descripción',
      subtasks: 'Subtareas',
      subtasksHint: 'Mostrar progreso de subtareas',
    },
    eyebrow: 'Ajustes',
    title: 'Preferencias',
    appearance: { title: 'Apariencia', description: 'Elige el tema que se adapte al momento.' },
    language: { title: 'Idioma', description: 'Idioma de menús y etiquetas.' },
    desktop: {
      title: 'Escritorio',
      description:
        'Comportamiento nativo en macOS / Windows / Linux. Solo se aplica en la app de escritorio.',
      alwaysOnTopLabel: 'Siempre encima',
      alwaysOnTopHint: 'Mantiene la ventana sobre todas las demás apps hasta que lo desactives.',
      globalHotkeyLabel: 'Atajo global de captura rápida',
      globalHotkeyHint:
        '⌘⇧Space en todo el sistema — abre DoneLine y enfoca el campo de captura desde cualquier sitio.',
    },
    account: {
      title: 'Cuenta',
      description: 'Información de inicio de sesión y resumen.',
      summary: '{tasks} tareas · {projects} proyectos',
      signOut: 'Cerrar sesión',
      deleteAccount: 'Eliminar cuenta',
      deleteAccountConfirmTitle: '¿Eliminar la cuenta?',
      deleteAccountConfirmBody:
        'Se eliminarán de forma permanente tu cuenta y todas tus tareas, proyectos y etiquetas, tanto en nuestros servidores como en este navegador. No se puede deshacer. Exporta tus datos antes si quieres conservarlos.',
      deleteAccountConfirm: 'Eliminar',
      deleteAccountFailed: 'No se pudo eliminar la cuenta',
      signingOut: 'Cerrando sesión…',
      notSignedIn: 'No has iniciado sesión',
      signInCta: 'Iniciar sesión',
      guestHint:
        'Modo invitado: los datos permanecen en este dispositivo. Inicia sesión para activar la sincronización y las copias.',
      displayNameLabel: 'Nombre para mostrar',
      displayNamePlaceholder: 'Tu nombre',
      displayNameSaved: 'Guardado',
      displayNameSaveFailed: 'Error al guardar',
      avatarLabel: 'Avatar',
      avatarHint: 'JPG, PNG, WEBP o GIF, hasta 2 MB. Vacío muestra la inicial.',
      avatarUpload: 'Subir imagen',
      avatarChange: 'Cambiar imagen',
      avatarUploading: 'Subiendo…',
      avatarRemove: 'Quitar',
      avatarSaved: 'Avatar actualizado',
      avatarSaveFailed: 'Error al actualizar el avatar',
      avatarErrorType: 'Formato no admitido. Usa JPG, PNG, WEBP o GIF.',
      avatarErrorSize: 'Imagen demasiado grande. Máximo 2 MB.',
    },
    sync: {
      title: 'Sincronización',
      description: 'Realiza una sincronización incremental completa ahora.',
      forceSync: 'Sincronizar ahora',
      syncing: 'Sincronizando…',
      done: 'Sincronización completa',
    },
    shortcuts: {
      title: 'Atajos de teclado',
      description: 'El teclado es el puntero más rápido.',
      view: 'Ver atajos',
    },
    data: {
      title: 'Datos',
      description: 'Todos los datos se guardan localmente primero y luego se sincronizan.',
      export: 'Exportar JSON',
      import: 'Importar JSON',
      exportDone: '{n} tareas exportadas',
      importDone: '{n} nuevos elementos importados',
      importError: 'Error al importar: {error}',
      importPersistFailed:
        'No se pudo guardar la importación en el almacenamiento local: los datos pueden superar el límite del dispositivo. Importa en lotes más pequeños.',
      clearAll: 'Borrar datos locales',
      clearConfirmTitle: '¿Borrar todos los datos locales?',
      clearConfirmDesc:
        'Se eliminará todo lo guardado en este navegador. Los datos sincronizados en el servidor no se ven afectados. La página se recargará al terminar.',
      cleared: 'Borrado. Recargando…',
    },
    about: {
      title: 'Acerca de',
      version: 'Versión {v}',
      description: 'Un gestor personal de tareas y proyectos inspirado en GTD.',
    },
  },
  guest: {
    banner:
      'Modo invitado — los datos solo se guardan en este dispositivo. Inicia sesión para sincronizar.',
    bannerCta: 'Iniciar sesión',
    emptyHint:
      'Hasta que inicies sesión, tus datos se quedan solo en este dispositivo. Añade tu primera tarea abajo.',
    storageWarning:
      'Los datos de invitado viven solo en este navegador y el sistema podría borrarlos. Inicia sesión o exporta con regularidad (los archivos exportados no van cifrados).',
  },
  login: {
    welcomeBack: 'Bienvenido de nuevo',
    helperSupabase: 'Introduce tu correo y te enviaremos un enlace de inicio de sesión.',
    helperLocal:
      'Modo local: introduce cualquier correo para iniciar sesión inmediatamente (cuando Supabase no está configurado).',
    emailPlaceholder: 'tu@ejemplo.com',
    sendLink: 'Enviar enlace',
    sendingLink: 'Enviando…',
    sentSupabase: 'Enviado a {email}. Haz clic en el enlace de tu correo.',
    otpPrompt: 'O introduce el código del correo',
    otpPlaceholder: 'Código de 6 dígitos',
    otpSubmit: 'Iniciar sesión',
    otpFailed: 'Ese código no es válido o ha caducado',
    sentLocal: 'Sesión iniciada como {email}. Cargando…',
    modeSupabase: 'Supabase Auth',
    modeLocal: 'Modo Mock local (sin backend configurado)',
    skipGuest: 'Omitir — usar en local',
    skipFailed:
      'No se pudo activar el modo invitado (fallo de almacenamiento local). Inténtalo de nuevo.',
    merge: {
      title: 'Hay {count} tareas en este dispositivo',
      keep: 'Fusionarlas con mi cuenta',
      irreversible: 'Se subirán tras iniciar sesión. La fusión no se puede deshacer.',
      discard: 'No conservar los datos locales',
      discardConfirmTitle: 'Tras iniciar sesión se eliminarán {count} tareas locales',
      discardConfirmBody:
        'Al completar el inicio de sesión, las {count} tareas de este dispositivo se eliminarán de forma permanente y no se podrán recuperar. ¿Continuar?',
    },
    error: 'Error al iniciar sesión',
  },
  task: {
    recurringAdvanced: 'Repetición — movida al {date}',
    recurringFinished: 'Repetición finalizada — tarea completada',
    titlePlaceholder: 'Título de la tarea',
    description: 'Descripción',
    descriptionPlaceholder: 'Añadir una descripción…',
    descriptionEmpty: 'Sin descripción.',
    descriptionEdit: 'Editar descripción',
    descriptionSave: 'Guardar descripción',
    descriptionCancel: 'Cancelar',
    save: 'Guardar',
    saved: 'Guardado',
    discardConfirmTitle: '¿Descartar cambios sin guardar?',
    discardConfirmDesc: 'Tienes ediciones sin guardar. Si cierras ahora, se perderán.',
    priority: 'Prioridad',
    date: 'Fecha',
    project: 'Proyecto',
    section: 'Sección',
    parentTask: 'Tarea padre',
    tags: 'Etiquetas',
    subtasks: 'Subtareas',
    expandSubtasks: 'Mostrar subtareas',
    collapseSubtasks: 'Ocultar subtareas',
    addSubtaskPlaceholder: '+ Añadir subtarea',
    comments: 'Comentarios',
    noComments: 'Sin comentarios todavía',
    commentPlaceholder: 'Escribir comentario…',
    sendComment: 'Enviar',
    delete: 'Eliminar',
    deleteConfirmTitle: '¿Eliminar esta tarea?',
    deleteConfirmDesc: 'Las subtareas también se eliminarán.',
    saveHint: '⌘/Ctrl + Enter para guardar y cerrar',
    open: 'Abrir',
    completed: 'Completada',
    markComplete: 'Marcar como completada',
    markIncomplete: 'Marcar como pendiente',
    moreActions: 'Más acciones',
  },
  priority: {
    high: 'Alta',
    mid: 'Media',
    low: 'Baja',
    none: 'Ninguna',
    p1: 'P1',
    p2: 'P2',
    p3: 'P3',
    p4: 'P4',
  },
  date: {
    picker: {
      single: 'Día',
      datetime: 'Hora',
      range: 'Rango',
      today: 'Hoy',
      tomorrow: 'Mañana',
      thisWeekend: 'Este fin de semana',
      nextWeek: 'Próxima semana',
      noDate: 'Sin fecha',
    },
    overdue: 'Atrasada',
    notScheduled: 'Sin fecha',
  },
  recurrence: {
    title: 'Repetir',
    none: 'No se repite',
    custom: 'Personalizado…',
    applyCustom: 'Aplicar regla personalizada',
    end: 'Finalizar repetición',
    preset: {
      daily: 'Diariamente',
      weekdays: 'Cada día laborable',
      weekly: 'Semanalmente',
      biweekly: 'Cada 2 semanas',
      monthly: 'Mensualmente',
      yearly: 'Anualmente',
    },
    summary: {
      daily: 'Diariamente',
      everyNDays: 'Cada {n} días',
      weekly: 'Semanalmente',
      everyNWeeks: 'Cada {n} semanas',
      weeklyOn: 'Semanalmente los {days}',
      everyNWeeksOn: 'Cada {n} semanas los {days}',
      monthly: 'Mensualmente',
      everyNMonths: 'Cada {n} meses',
      yearly: 'Anualmente',
      everyNYears: 'Cada {n} años',
    },
    weekday: { sun: 'Dom', mon: 'Lun', tue: 'Mar', wed: 'Mié', thu: 'Jue', fri: 'Vie', sat: 'Sáb' },
    freq: { daily: 'Día(s)', weekly: 'Semana(s)', monthly: 'Mes(es)', yearly: 'Año(s)' },
    every: 'Cada',
  },
  aiUsage: {
    title: 'Uso de IA',
    planFree: 'Plan gratuito',
    planPro: 'Plan Pro',
    planProAi: 'Plan Pro AI',
    usedOf: '{used} / {limit} este mes',
    remaining: 'Restantes: {count}',
    resetsMonthly: 'Se restablece el día 1 de cada mes (UTC)',
    history: 'Actividad reciente',
    historyEmpty: 'Aún sin uso de IA',
    endpointParse: 'Análisis IA',
    endpointBreakdown: 'Desglose IA',
    signInFirst: 'Inicia sesión para ver tu uso',
    loadFailed: 'No se pudo cargar',
    retry: 'Reintentar',
  },
  parseTask: {
    mode: 'IA',
    quickMode: 'Rápido',
    title: 'Análisis de tareas con IA',
    placeholder: 'Describe una tarea con tus palabras…',
    titlePlaceholder: 'Título de la tarea',
    hint: 'La IA completa fecha, prioridad, proyecto y etiquetas',
    parse: 'Analizar',
    confirm: 'Añadir tarea',
    confirmMany: 'Añadir {count} tareas',
    back: 'Atrás',
    voice: 'Entrada de voz',
    voiceDenied: 'Permiso de micrófono denegado',
    voiceUnavailable: 'Entrada de voz no compatible con este navegador',
    errors: {
      rateLimited: 'Demasiadas solicitudes: inténtalo de nuevo en un momento',
      monthlyLimit: 'Cuota mensual de IA agotada: mejora tu plan para obtener más',
      unauthorized: 'Inicia sesión para usar la IA',
      unavailable: 'La IA no está disponible por ahora',
      failed: 'No se pudo analizar la tarea; prueba a reformularla',
    },
  },
  quickCapture: {
    placeholder: 'Añadir tarea… (Enter para guardar)',
    hint: 'Prueba: "Comprar leche tomorrow @vida #rápido p2"',
    newTag: '#{name} (nueva)',
    dismissMatch: 'Mantener "{label}" como texto',
    createTag: 'Crear etiqueta "{name}"',
    syntaxCheatsheet: 'today / tomorrow / next mon · @proyecto[/sección] · #etiqueta · p1-p4',
    add: 'Añadir',
    open: 'Abrir captura rápida',
    addTask: 'Añadir tarea',
  },
  tag: {
    eyebrow: 'Etiqueta',
    editTagTitle: 'Editar etiqueta',
    renameTagPlaceholder: 'Nombre de la etiqueta',
    newTagPlaceholder: 'Nueva etiqueta…',
    deleteTagTitle: '¿Eliminar la etiqueta "{name}"?',
    deleteTagDesc: 'Se quitará de {count} tarea(s). No se puede deshacer.',
    actionsMenu: 'Acciones de etiqueta',
    nameTaken: 'Ya existe una etiqueta con ese nombre',
    empty: 'No hay tareas con esta etiqueta',
  },
  quickbar: {
    signInRequired: 'Inicia sesión',
    signInHint: 'Inicia sesión primero para capturar tareas desde la barra de menú.',
    signInOpenMain: 'Abre la ventana principal de DoneLine para iniciar sesión',
  },
  sync: {
    idle: 'Sincronizado',
    syncing: 'Sincronizando',
    offline: 'Sin conexión',
    error: 'Error de sincronización',
    disabled: 'Modo local',
    pending: '{count} pendientes',
    syncingPending: 'Sincronizando · {count} pendientes',
    offlinePending: 'Sin conexión · {count} pendientes',
    authError: 'Autenticación fallida — inicia sesión de nuevo',
    rejectedBatch: 'Data validation failed — some changes were dropped',
    retry: 'Clic para reintentar',
  },
  commandPalette: {
    placeholder: 'Buscar tareas, ir a una vista o ejecutar una acción…',
    empty: 'Sin coincidencias.',
    tasks: 'Tareas',
    projects: 'Proyectos',
    navigation: 'Navegación',
    actions: 'Acciones',
  },
  bulk: {
    toolbar: 'Acciones en lote',
    selected: '{count} seleccionadas',
    clear: 'Limpiar',
    deleteTitle: '¿Eliminar {count} tarea(s)?',
    deleteDesc: 'Las subtareas también se eliminarán. Esta acción no se puede deshacer.',
    mixedProjects: 'Varios proyectos',
  },
  shortcuts: {
    title: 'Atajos de teclado',
    quickAdd: 'Captura rápida',
    search: 'Buscar',
    help: 'Mostrar este panel',
    gotoToday: 'Ir a Hoy',
    gotoInbox: 'Ir a Bandeja',
    gotoUpcoming: 'Ir a Próximos',
    drawer: {
      title: 'En el detalle de tarea',
      saveClose: 'Guardar y cerrar',
      delete: 'Eliminar tarea',
      priorityKeys: 'Establecer prioridad (1=Alta … 4=Ninguna)',
    },
  },
  welcome: {
    title: 'Bienvenido a {brand}',
    subtitle: 'Empezamos en 30 segundos.',
    step1: {
      title: 'Captura todo en un segundo',
      body: 'Pulsa Q en cualquier página para abrir captura rápida. Escribe una tarea y pulsa Enter — va directo a tu Bandeja.',
    },
    step2: {
      title: 'Organiza cuando tengas tiempo',
      body: 'Arrastra tareas a Proyectos y Secciones. Añade fecha, prioridad o etiquetas más tarde.',
    },
    step3: {
      title: 'Planifica tu día',
      body: 'La vista Hoy reúne automáticamente lo que vence hoy y los rangos de fecha que incluyen hoy.',
    },
    step4: {
      title: 'Listo',
      body: 'Hemos añadido algunas tareas iniciales para que explores. Márcalas como hechas o bórralas cuando quieras.',
    },
    getStarted: 'Empezar',
  },
  onboarding: {
    project: { welcome: 'Bienvenida', learn: 'Aprender' },
    tasks: {
      welcome: '👋 ¡Bienvenido a {brand}!',
      welcomeDesc:
        'Haz clic en la casilla de la izquierda para marcar esta tarea como hecha. Así se completan las tareas.',
      quickAdd: '⚡ Prueba la captura rápida: pulsa Q o el botón superior izquierdo',
      quickAddDesc:
        'Escribe el título y pulsa Enter. Usa @proyecto para asignarlo, #etiqueta para etiquetar, p1-p4 para prioridad.',
      organize: '📁 Agrupa tareas relacionadas en Proyectos',
      organizeDesc: 'Pulsa "+ Nuevo proyecto" en la barra lateral. Arrastra tareas dentro.',
      schedule: '🗓 Pon una fecha para planificar',
      scheduleDesc:
        'Las tareas con fecha de hoy aparecen en la vista Hoy. Abre esta tarea y dale una fecha límite.',
      priority: '🔥 Usa prioridades (P1=Alta, P4=Ninguna)',
      priorityDesc: 'Pulsa 1 / 2 / 3 / 4 en el detalle para cambiar prioridad rápidamente.',
      drag: '✋ Arrastra para reordenar',
      dragDesc:
        'Pasa el ratón por una tarea y aparecerá un asa a la izquierda. Arrástrala donde quieras.',
      gantt: '📊 Visualiza con Gantt',
      ganttDesc:
        'Abre cualquier proyecto y cambia a la pestaña "Gantt" para ver las tareas en una línea de tiempo.',
      reports: '📈 Reflexiona con el Informe semanal',
      reportsDesc: 'Mira qué completaste y qué se pospuso cada semana.',
      finishMe: '✅ Marca esta lista como hecha — ¡estás listo!',
    },
  },
  errors: {
    networkError: 'Error de red',
    unknownError: 'Error desconocido',
    notFound: 'No encontrado',
    pageNotFound: 'Página no encontrada',
    pageNotFoundDesc: 'Esta URL no existe o se ha movido.',
    backHome: 'Volver a Hoy',
    somethingWrong: 'Algo salió mal',
    tryAgain: 'Reintentar',
    goHome: 'Ir al inicio',
  },
  theme: {
    light: 'Claro',
    dark: 'Oscuro',
    paper: 'Papel',
    rose: 'Rosa',
    lavender: 'Lavanda',
    peach: 'Durazno',
    mauve: 'Malva',
    slate: 'Pizarra',
    forest: 'Bosque',
    midnight: 'Medianoche',
    shiba: 'Shiba',
    cat: 'Gato',
    ocean: 'Océano',
    sky: 'Cielo',
    mint: 'Menta',
    matcha: 'Matcha',
    amber: 'Ámbar',
    mocha: 'Moca',
    crimson: 'Carmesí',
    nord: 'Nord',
    dracula: 'Drácula',
    graphite: 'Grafito',
    system: 'Sistema',
    pickerTitle: 'Tema',
  },
} as const;
